import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { environment } from "src/environments/environment";
import { ElectorDataService } from "../Services/elector-data.service";

@Injectable()
export class CanActivateVerifyMFA {
    constructor(private router: Router, private userService: ElectorDataService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if(this.userService.userAuthData()?.mfaMethod !== undefined && (this.userService.userAuthData()?.attemptsRemaining ?? 0) > 0) {
            return true
        }
        else {
            return this.router.createUrlTree(environment.startRoute)
        }
    }
}